/**
 * Temporary toggles for content that needs to be hidden or replaced without
 * removing the underlying implementation. Flip these back to `false` to
 * restore the original experience.
 */

// Replaces the full loyalty program page with a "we're improving" notice.
export const LOYALTY_PROGRAM_UNDER_MAINTENANCE = false;

// Blocks interaction with the New York gift card option and covers it with a
// "Coming Soon" overlay until New York gets its own storefront link.
export const NY_GIFT_CARDS_COMING_SOON = true;
